@if ((flagService.getFlags$() | async)?.[FeatureFlags.PRIVATE_LAYERS]) {
    <div class="map-toolbar" >
        <button

                matIconButton
                class="mat-icon-toggle-button"
                id="user-data-toolbar-button"
                [class.selected]="displayPanel"
                type="button"
                matTooltip="{{ !displayPanel ? 'My data' : null }}"
                (click)="togglePanelDisplay()"
                matTooltipPosition="right">
            <mat-icon svgIcon="my_data"></mat-icon>
        </button>

        <div class="toolbar-panel-container" [hidden]="!displayPanel">
            <div class="user-data-container">
                <div class="my-3 user-data-header">
                    <h6>My Data</h6>
                </div>
                <mat-divider></mat-divider>
                <div class="my-3 col-md-12 justify-content-center">
                    <button matButton="elevated" class="w-100" (click)="showUploadDialog()">
                        <mat-icon>backup</mat-icon>
                        Click here to add data
                    </button>
                    <phoenix-user-data-list
                            (onShowUploadDialog)="onShowUploadDialog($event)"
                            [selectedFeatures]="viewerService.selectedFeatures$ | async"
                            [layers]="viewerService.userLayers$ | async"></phoenix-user-data-list>
                </div>
            </div>
        </div>

    </div>
}
